import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import type { GroundSupplier } from "@b2bportal/ground-api";
import { useFilterSuppliers } from "@tenant/cars";
import { CheckboxGroup } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./FilterSuppliers.module.scss";
import { useCarsStyles } from "~core-cars/themes";
import { CoreCarsComponent } from "~core-cars/types";

export type FilterSuppliersProps = {
  selectedValues: GroundSupplier[];
  onChange: (values: GroundSupplier[]) => void;
  options: GroundSupplier[];
} & PlatformComponentProps;

const COMPONENT_KEY = CoreCarsComponent.FilterSuppliers;

export const FilterSuppliers = (props: FilterSuppliersProps) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { className } = props;
  const { onChange, selectedValues, items, getSelectedSupplier } =
    useFilterSuppliers(props);
  return (
    <div className={clsx(block, className)}>
      <CheckboxGroup
        className={cn("checkbox-group")}
        options={items}
        checkedOptions={selectedValues.map((s) => s.name)}
        onOptionsChange={(v) => {
          const suppliers = getSelectedSupplier(v);
          onChange(suppliers);
        }}
      />
    </div>
  );
};
